function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "background"), React.createElement("rect", {
  fill: "#fff",
  id: "canvas_background",
  height: 402,
  width: 582,
  y: -1,
  x: -1
}), React.createElement("g", {
  display: "none",
  overflow: "visible",
  y: 0,
  x: 0,
  height: "100%",
  width: "100%",
  id: "canvasGrid"
}, React.createElement("rect", {
  fill: "url(#gridpattern)",
  strokeWidth: 0,
  y: 0,
  x: 0,
  height: "100%",
  width: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("text", {
  fontWeight: "bold",
  xmlSpace: "preserve",
  textAnchor: "start",
  fontFamily: "'Simonetta', serif",
  fontSize: 24,
  id: "svg_1",
  y: 28.447917,
  x: 9.5,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "Fashionista"));

var SvgLogoFashionista = function SvgLogoFashionista(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 580,
    height: 400,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoFashionista, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_fashionista.c65c3854.svg";
export { ForwardRef as ReactComponent };